import { METALICO_CON_TARJETA_ID, METALICO_ID, TRANSFERENCIA_ID } from '@/models/gestion_economica/FormaPago';
import ApplicationController from '../application_controller';

const CONF_IMPRIMIR_RECIBI = 'cobros-imprimir-recibi';

export default class extends ApplicationController {
  connect() {
    this.estadoSelect = this.element.querySelector('#cambiar_estado_estado');
    this.formaPagoSelect = this.element.querySelector('#cambiar_estado_forma_pago_id');
    this.importeRecibidoInput = this.element.querySelector('#cambiar_estado_importe_recibido');
    this.wrapperImprimirRecibi = this.element.querySelector('#wrapper-imprimir-recibi');
    this.checkboxImprimirRecibi = this.wrapperImprimirRecibi?.querySelector('input[type="checkbox"]');

    this.estadoInicial = this.estadoSelect.value;
    this.puedeImporteRecibido = !!this.importeRecibidoInput;

    this.attachEventListeners();
    this.restaurarEstadoImprimirRecibi();
    // Disparar el evento change inicial para configurar el estado correcto
    this.handleStateChange();
  }

  attachEventListeners() {
    this.estadoSelect.addEventListener('change', this.handleStateChange.bind(this));
    this.formaPagoSelect.addEventListener('change', this.handleStateChange.bind(this));

    if (this.puedeImporteRecibido) {
      this.importeRecibidoInput.addEventListener('input', this.handleStateChange.bind(this));
      // Guardar estado solo en submit del formulario
      this.element.addEventListener('submit', this.guardarEstadoImprimirRecibi.bind(this));
    }
  }

  handleStateChange() {
    const estado = this.estadoSelect.value;

    // Mostrar/ocultar campos según el estado
    this.toggleElement('.cambiar_estado_fecha_cobro', estado === 'cobrado' || estado === 'pendiente');
    this.toggleElement('.cambiar_estado_recrear_factura', estado === 'cancelado');
    this.toggleElement('.cambiar_estado_serie_id', estado === 'cancelado');

    if (this.puedeImporteRecibido) {
      this.handleStateChangeImporteRecibido();
    } else {
      // Si no pueden imprimir, ocultar el wrapper
      this.wrapperImprimirRecibi.style.display = 'none';
    }
  }

  handleStateChangeImporteRecibido() {
    const estado = this.estadoSelect.value;
    const formaPagoId = parseInt(this.formaPagoSelect.value, 10);

    const mostrarImporteRecibido = estado === 'pendiente'
      && (
        formaPagoId === METALICO_ID
        || formaPagoId === METALICO_CON_TARJETA_ID
        || formaPagoId === TRANSFERENCIA_ID
      );

    this.toggleElement('.cambiar_estado_importe_recibido', mostrarImporteRecibido);

    // Limpiar el valor del input si no está visible
    const importeRecibidoInput = this.element.querySelector('.cambiar_estado_importe_recibido input');
    if (!mostrarImporteRecibido && importeRecibidoInput) {
      importeRecibidoInput.value = '';
    }

    const importeRecibido = importeRecibidoInput ? parseFloat(importeRecibidoInput.value) : 0;
    if (this.wrapperImprimirRecibi) {
      // Si inicialmente el estado es cobrado, no pueden imprimir
      if (importeRecibido > 0 || (this.estadoInicial !== 'cobrado' && estado === 'cobrado')) {
        this.restaurarEstadoImprimirRecibi();
        this.wrapperImprimirRecibi.style.display = '';
      } else {
        this.wrapperImprimirRecibi.style.display = 'none';
        // Solo limpiar el checkbox si se oculta el wrapper
        if (this.checkboxImprimirRecibi) {
          this.checkboxImprimirRecibi.checked = false;
        }
      }
    }
  }

  toggleElement(selector, show) {
    const element = this.element.querySelector(selector);
    if (element) {
      element.style.display = show ? '' : 'none';
    }
  }

  restaurarEstadoImprimirRecibi() {
    if (!this.checkboxImprimirRecibi) return;

    const estadoGuardado = localStorage.getItem(CONF_IMPRIMIR_RECIBI);

    if (estadoGuardado !== null) {
      this.checkboxImprimirRecibi.checked = estadoGuardado === 'true';
    }
  }

  guardarEstadoImprimirRecibi() {
    if (!this.checkboxImprimirRecibi) return;

    localStorage.setItem(CONF_IMPRIMIR_RECIBI, this.checkboxImprimirRecibi.checked.toString());
  }

  disconnect() {
    // Limpiar event listeners al desconectar el controlador
    this.estadoSelect.removeEventListener('change', this.handleStateChange.bind(this));
    this.formaPagoSelect.removeEventListener('change', this.handleStateChange.bind(this));

    if (this.puedeImporteRecibido) {
      this.importeRecibidoInput.removeEventListener('input', this.handleStateChange.bind(this));
      this.element.removeEventListener('submit', this.guardarEstadoImprimirRecibi.bind(this));
    }
  }
}
